import { render, staticRenderFns } from "./listaProductos.vue?vue&type=template&id=7d145a9c&scoped=true"
import script from "./listaProductos.vue?vue&type=script&lang=js"
export * from "./listaProductos.vue?vue&type=script&lang=js"
import style0 from "./listaProductos.vue?vue&type=style&index=0&id=7d145a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d145a9c",
  null
  
)

export default component.exports